export default {"src":"/_next/static/media/notifications.28ebdfb5.gif","height":300,"width":400};